import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { FilterIcon } from 'foundations-assets/icons/components/FilterIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FilterPanelButton({
  onFilterPanelOpen
}) {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const handleOpen = () => {
    onFilterPanelOpen();
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'filter panel opened'
    }));
  };
  return /*#__PURE__*/_jsxs(Button, {
    onClick: handleOpen,
    use: "secondary",
    "data-prevent-inherit-border-radius": "true",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: FilterIcon,
      padding: "0"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceStorefront.filters.moreFilters"
    })]
  });
}